import { Component } from 'react';
import { connect } from "react-redux";
import { fireAppCrash } from "../actions/index";
import { errorlog } from '../helpers/ErrorLogService';

class ErrorHandler extends Component {
  static errorId;
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
      
    }, () => {
      if(!ErrorHandler.errorId) {
        ErrorHandler.errorId = errorlog(this.state.error, this.state.errorInfo, this.props.component, true);
      }
      this.setState({
        errorId: ErrorHandler.errorId,
      })
    });
  }

  render() {
    if (!this.state.error) 
      return this.props.children;
    // else if(this.state.errorId)
    //   this.props.fireAppCrash(this.state.errorId, this.state.error);
    
      return null;
  }
}

export default connect(null, (dispatch) => ({
  fireAppCrash: (errorId, error) => {dispatch(fireAppCrash(errorId, error))}
}))(ErrorHandler);


// WEBPACK FOOTER //
// ./src/helpers/ErrorHandler.js